import { render } from "./menu.svg?vue&type=template&id=c9149dc0"
const script = {}

import exportComponent from "/buddy/bio-effect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__